import * as React from 'react';
import { updateQueryParam } from '@features/utils/functions';
import IPagination from './IPagination';
import Chevron from "@images/chevron.svg";
import * as style from './paginationStyles.module.scss'

export default class Pagination extends React.PureComponent<IPagination> {

  prevPage = () => {
    if (this.props.currentPage - 1 === 0) return;
    if (this.props.history) {
      this.saveHistory(this.props.currentPage - 1);
    } else {
      this.props.filterData(this.props.currentPage - 1);
    }
    this.scroll();
  }

  nextPage = () => {
    if (this.props.currentPage * this.props.maxPerPage >= this.props.totalCount) return;
    if (this.props.history) {
      this.saveHistory(this.props.currentPage + 1);
    } else {
      this.props.filterData(this.props.currentPage + 1);
    }
    this.scroll();
  }

  changePage = (page:number) => {
    if (page === this.props.currentPage) return;
    if (this.props.history) {
      this.saveHistory(page);
    } else {
      this.props.filterData(page);
    }
    this.scroll();
  }


  saveHistory = (num: number = this.props.currentPage) => {
    if (this.props.history) {
      if (this.props.history.location.search) {
        const url = updateQueryParam(this.props.history.location.search, 'page', num);
        this.props.history.push(`${this.props.history.location.pathname}${url}`);
      } else {
        this.props.history.push(`${this.props.history.location.pathname}?page=${num}`);
      }
    }
  }

  scroll = () => {
    this.props.scrollTop ? window.scrollTo(0,0) : null;
  }

  generateDesktopButtons = () => {
    const buttons:object[] = [];
    const buttonsAmount = Math.ceil(this.props.totalCount / this.props.maxPerPage);
    const amountToDisplayAll = 4;
    let dotsBeforeFlag, dotsAfterFlag = false;

    const pushButton = (index:number) => {
      const isActive = index === this.props.currentPage;
      buttons.push(
        <button
          onClick={() => {this.changePage(index);}}
          key={index}
          className={style.pagination__button}
          data-active={isActive}
          type="button"
        >
          {index}
        </button>
      );
    };

    for (let i = 1; i <= buttonsAmount; i += 1) {
      if (buttonsAmount <= amountToDisplayAll) {
        pushButton(i);
      } else if (
          i === this.props.currentPage ||
          i === this.props.currentPage - 1 ||
          i === this.props.currentPage + 1 ||
          i === buttonsAmount ||
          i === 1
        ) {
        pushButton(i);
      } else if (!dotsBeforeFlag && i < this.props.currentPage) {
        dotsBeforeFlag = true;
        buttons.push(<span key={i} className={style.pagination__dots}>...</span>);
      } else if (!dotsAfterFlag && i > this.props.currentPage) {
        dotsAfterFlag = true;
        buttons.push(<span key={i} className={style.pagination__dots}>...</span>);
      }
    }

    return buttons;
  }

  generateMobileSelectOptions = () => {
    const options = [];
    const optionsAmount = Math.ceil(this.props.totalCount / this.props.maxPerPage);

    for (let i = 1; i <= optionsAmount; i += 1) {
      options.push(<option key={i} value={i}>Page {i} of {optionsAmount}</option>);
    }

    return options;
  }

  selectChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    this.changePage(Number(e.target.value));
  }

  render() {
    return (
      this.props.totalCount > this.props.maxPerPage &&
      (
        <div className={style.pagination}>
          <div className={style.desktopHolder}>
            <button className={style.pagination__leftButton} onClick={this.prevPage} type="button">
              <Chevron /> 
            </button>
            {this.generateDesktopButtons()}
            <button className={style.pagination__rightButton} onClick={this.nextPage} type="button">
              <Chevron />
            </button>
          </div>

          <div className={style.mobileHolder}>
            <select className={style.mobileSelect} value={this.props.currentPage} onChange={this.selectChange}>
              {this.generateMobileSelectOptions()}
            </select>
          </div>
      </div>
      )
    );
  }
}

